// eslint-disable-next-line
import { useGoogleLogin } from '@react-oauth/google';
import { Button } from 'Components';
import { AxiosCancelToken, axios, dataFetcher, endpoints, baseUrl } from 'Api';
import Google from '../../../../Assets/google.svg';
import styles from './index.module.css';

const GoogleLoginButton = ({ loginWithSocial }) => {
const login = useGoogleLogin({
  onSuccess: async (tokenResponse) => {
    console.log('Google Login Success:', tokenResponse);
    loginWithSocial(tokenResponse, 'google');
  },
  onError: () => {
    console.log('Google Login Failed');
  },
});

  return (
    <Button
      isGrayWhiteText
      isFullWidth
      alignCenter
      blockText
      onClick={login} // ✅ triggers Google login
      type="button"
    >
      <img className={styles.buttonLogoGoogle} src={Google} alt="Google" />
      Continue with Google
    </Button>
  );
};

export default GoogleLoginButton;
